const COOKIE_KEY_PREFIX = 'diy-step';
const COOKIE_EXPIRES_DAYS = 30;

const cookieKey = (catalogID) => `${COOKIE_KEY_PREFIX}-${String(catalogID)}`;

export const getDiyStep = (catalogID) => {
  const key = cookieKey(catalogID);
  const entry = document.cookie.split('; ').find(row => row.startsWith(`${key}=`));
  return entry ? entry.split('=')[1] : undefined;
};

const setDiyStep = (catalogID, stepNumber) => {
  const expires = new Date();
  expires.setDate(expires.getDate() + COOKIE_EXPIRES_DAYS);
  document.cookie = `${cookieKey(catalogID)}=${stepNumber}; path=/; expires=${expires.toUTCString()}`;
};

const updateStepTracker = (catalogID, stepNumber) => {
  if (!catalogID || catalogID === '0') return;
  setDiyStep(catalogID, stepNumber);
  return fetch(`/cps/app/diy-step-tracker/${catalogID}`, {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: String(stepNumber)
  }).catch((error) => console.error('Failed to update DIY step tracker', { catalogID, stepNumber, error }));
};

export default updateStepTracker;
